import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { useEnumStrings } from "../enumStrings";

const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      border: "unset",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      borderRadius: "20px",
      textAlign: "center",
      maxHeight: "833px",
      width: "966px",
      maxWidth: "95vw",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      backgroundColor: "#E6E6E6",
      padding: "30px",
      paddingTop: "46px",
      position: "relative",
      outline: "none",
      fontFamily: "DM Sans, sans-serif",
    },
    closeButton: {
      position: "absolute",
      top: "16px",
      right: "16px",
      width: "30px",
      height: "30px",
      backgroundColor: "#ED1C24",
      borderRadius: "100px",
      color: "#FFFFFF",
      padding: 0,
      "&:hover": {
        backgroundColor: "#D41920",
      },
    },
    title: {
      fontFamily: "DM Sans, sans-serif",
      fontWeight: 700,
      fontSize: "25px",
      color: "#000000",
      marginBottom: "24px",
      marginTop: 0,
    },
    contentBox: {
      width: "100%",
      maxWidth: "906px",
      height: "602px",
      maxHeight: "55vh",
      overflowY: "scroll",
      backgroundColor: "#FFFFFF",
      border: "1px solid #000000",
      borderRadius: "16px",
      textAlign: "left",
      padding: "35px 41px",
    },
    contentText: {
      fontFamily: "DM Sans, sans-serif",
      fontWeight: 400,
      fontSize: "24px",
      lineHeight: "200%",
      color: "#000000",
      margin: 0,
      "& h2": {
        fontWeight: 700,
        fontSize: "24px",
        lineHeight: "200%",
        margin: "0",
      },
      "& p": {
        margin: "0 0 8px 0",
      },
    },
    buttonRow: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: "40px",
      marginTop: "24px",
    },
    acceptButton: {
      width: "290px",
      height: "54px",
      backgroundColor: "#E1A731",
      color: "#FFFFFF",
      borderRadius: "12px",
      fontFamily: "DM Sans, sans-serif",
      fontWeight: 600,
      fontSize: "18px",
      letterSpacing: "-0.04em",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#C48E1C",
      },
    },
  })
);

const ChamberMemberMemberProfileAndPerksBannersAgreementModal = ({
  open,
  handleClose,
  handleAcceptanceOfChamberMemberMemberProfileAndPerksBannersAgreement,
  chamberName,
}: {
  open: boolean;
  handleClose: () => void;
  handleAcceptanceOfChamberMemberMemberProfileAndPerksBannersAgreement: () => void;
  chamberName: string;
  isCategoryBanner?: boolean;
}) => {
  const classes = useStyles();
  const enumStrings = useEnumStrings();

  const replaceName = (text: string): string =>
    text.replaceAll("{{chamberName}}", chamberName);

  return (
    <Modal className={classes.modal} open={open}>
      <div className={classes.paper}>
        {/* Close button */}
        <IconButton
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon style={{ fontSize: "18px" }} />
        </IconButton>

        {/* Title */}
        <h2 className={classes.title}>
          {enumStrings.chamberMember.modal.title}
        </h2>

        {/* Scrollable content area */}
        <div className={classes.contentBox}>
          <div className={classes.contentText}>
            <p>{enumStrings.chamberMember.agreement.lead}</p>

            <h2>{enumStrings.chamberMember.agreement.section1Title}</h2>
            <p>{replaceName(enumStrings.chamberMember.agreement.section1Text)}</p>

            <h2>{enumStrings.chamberMember.agreement.section2Title}</h2>
            <p>{replaceName(enumStrings.chamberMember.agreement.section2Text)}</p>

            <h2>{enumStrings.chamberMember.agreement.section3Title}</h2>
            <p>{replaceName(enumStrings.chamberMember.agreement.section3Text)}</p>

            <h2>{enumStrings.chamberMember.agreement.section4Title}</h2>
            <p>{replaceName(enumStrings.chamberMember.agreement.section4Text)}</p>

            <h2>{enumStrings.chamberMember.agreement.section5Title}</h2>
            <p>{enumStrings.chamberMember.agreement.section5Text}</p>
          </div>
        </div>

        {/* Button row */}
        <div className={classes.buttonRow}>
          <Button
            className={classes.acceptButton}
            onClick={() => {
              handleAcceptanceOfChamberMemberMemberProfileAndPerksBannersAgreement();
              handleClose();
            }}
            variant="contained"
            disableElevation
          >
            {enumStrings.chamberMember.buttons.accept}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChamberMemberMemberProfileAndPerksBannersAgreementModal;
